import React from "react";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material";
import PropTypes from "prop-types";

import { STATUS_CHIP } from "constants";

const StatusChip = ({ type, label, style = {}, ...rest }) => {
  const theme = useTheme();
  const internalStyle = {
    [STATUS_CHIP?.success]: {
      sx: {
        color: theme.palette.success?.dark,
        background: theme.palette.success?.main,
      },
    },
    [STATUS_CHIP?.warning]: {
      sx: {
        color: theme.palette.warning?.dark,
        background: theme.palette.warning?.main,
      },
    },
    [STATUS_CHIP?.error]: {
      sx: {
        color: theme.palette.error?.dark,
        background: theme.palette.error?.main,
      },
    },
    [STATUS_CHIP?.attention]: {
      sx: {
        color: theme.palette.orange?.dark,
        background: theme.palette.orange?.light,
      },
    },
    [STATUS_CHIP?.info]: {
      sx: {
        color: theme.palette.info?.main,
        background: theme.palette.info?.lightBlueBackround,
      },
    },
  };

  return (
    <Chip
      label={label}
      sx={{ ...internalStyle[type]?.sx, ...style }}
      size="small"
      {...rest}
    />
  );
};

StatusChip.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default React.memo(StatusChip);
